import React from "react";
import classnames from "classnames";

// Styles
import styles from "./info-box.module.scss";

function InfoBox({ children, className }) {
  return (
    <div className={classnames(styles["info-box"], className)} data-test="info-box">
      {children}
    </div>
  );
}

export default InfoBox;
